export default (params) => {
  const { fieldData, fieldType /* nodeType */ } = params;
  const {
    document: { nodes: documentNodes },
  } = fieldData;

  const filteredOrganizations = documentNodes.filter(
    (_, index) => index % 2 === 0,
  );

  /**
   * Iterate through organization and find the number of organization completely selected
   * also introduce the rolesCount in document data
   */
  const { length: noOfOrganizations } = filteredOrganizations;
  if (noOfOrganizations > 0) {
    let documentSelectAll = 0;
    let documentRolesCount = 0;
    let updatedOrganizationData = { ...fieldData };

    filteredOrganizations.forEach((organization, orgIndex) => {
      const { nodes: organizationNodes } = organization;

      let organizationSelectAll = 0;
      const filteredRoles = organizationNodes.filter(
        (_, index) => index % 2 !== 0,
      );

      filteredRoles.forEach((role) => {
        const {
          data: { toExport },
        } = role;
        if (toExport) {
          documentRolesCount += 1;
          organizationSelectAll += 1;
        }
      });

      /**
       * Updating & sanitizing organization data
       */
      updatedOrganizationData = {
        ...updatedOrganizationData,
        document: {
          ...updatedOrganizationData.document,
          nodes: [
            ...updatedOrganizationData.document.nodes.slice(0, orgIndex),
            {
              ...updatedOrganizationData.document.nodes[orgIndex],
              data: {
                ...updatedOrganizationData.document.nodes[orgIndex].data,
                selectAll: organizationSelectAll,
              },
            },
            ...updatedOrganizationData.document.nodes.slice(orgIndex + 1),
          ],
        },
      };

      const { length: noOfRoles } = filteredRoles;
      if (noOfRoles === organizationSelectAll) documentSelectAll += 1;
    });

    /**
     * Updating & sanitizing document data
     */
    updatedOrganizationData = {
      ...fieldData,
      document: {
        ...fieldData.document,
        data: {
          ...fieldData.document.data,
          rolesCount: documentRolesCount,
          selectAll: documentSelectAll,
          version: { number: 3, updated: true },
        },
      },
    };

    return { [fieldType]: updatedOrganizationData };
  }

  return null;
};
